import {initCalendar} from "../admin/calendar/calendar";

function initCustomerCalendarIndex(){
	initCalendar({},{},false)
}

export {initCustomerCalendarIndex}
